// src/game-system/races/halfling.js
import { BaseRace } from './baseRace';

const HALFLING_SUBRACES = {
  lightfoot: {
    name: "Lightfoot Halfling",
    description: "Stealthy and social halflings",
    attributeBonuses: {
      charisma: 1
    },
    traits: [
      {
        name: "Naturally Stealthy",
        description: "You can hide behind larger creatures",
        effect: {
          type: "passive",
          mechanics: "Can hide behind any creature at least one size larger"
        }
      }
    ]
  },
  stout: {
    name: "Stout Halfling",
    description: "Hardy and resilient halflings",
    attributeBonuses: {
      constitution: 1
    },
    traits: [
      {
        name: "Stout Resilience",
        description: "Enhanced resistance to poison",
        effect: {
          type: "passive",
          mechanics: "Advantage on saving throws against poison, resistance to poison damage"
        }
      }
    ]
  }
};

export class Halfling extends BaseRace {
  /**
   * @param {string} subrace - Halfling subrace name
   */
  constructor(subrace) {
    const subraceData = HALFLING_SUBRACES[subrace];
    if (!subraceData) {
      throw new Error(`Invalid halfling subrace: ${subrace}`);
    }

    const config = {
      name: subraceData.name,
      description: subraceData.description,
      attributeBonuses: {
        dexterity: 2,
        ...subraceData.attributeBonuses
      },
      traits: [
        {
          name: "Lucky",
          description: "Your people are naturally lucky",
          effect: {
            type: "passive",
            mechanics: "Reroll 1s on attack rolls, ability checks, and saving throws"
          }
        },
        {
          name: "Brave",
          description: "Your spirit is indomitable",
          effect: {
            type: "passive",
            mechanics: "Advantage on saving throws against being frightened"
          }
        },
        {
          name: "Halfling Nimbleness",
          description: "You can move through larger creatures",
          effect: {
            type: "passive",
            mechanics: "Can move through space of any creature larger than you"
          }
        },
        ...subraceData.traits
      ],
      cultures: [
        {
          name: "Riverside Communities",
          description: "Peaceful settlements along waterways",
          bonusSkills: ["Nature", "Survival"],
          startingEquipment: ["Fishing gear", "Small boat", "Comfortable clothes"],
          traditions: [
            {
              name: "River Friends",
              benefit: "Advantage on checks to handle small watercraft"
            }
          ]
        },
        {
          name: "Traveling Caravans",
          description: "Nomadic trading communities",
          bonusSkills: ["Animal Handling", "Persuasion"],
          startingEquipment: ["Trading goods", "Pony", "Maps"],
          traditions: [
            {
              name: "Trader's Intuition",
              benefit: "Advantage on checks to determine item value"
            }
          ]
        }
      ],
      size: {
        category: "Small",
        height: { min: 90, max: 100 },
        weight: { min: 20, max: 25 }
      },
      speed: 25,
      languages: {
        known: ["Common", "Halfling"],
        bonus: 0
      }
    };

    super(config);
    this.subrace = subrace;
  }
}